import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";
import { CtButtonConfiguration, MAT_RAISED_PRIMARY } from "@ctsolution/ct-framework";
import { TranslateService } from '@ngx-translate/core';

/**
 * Dati passati al dialog di errore duplicato nome
 */
export interface WorkOrderDuplicateNameDialogData {
  /** Nome duplicato rilevato */
  duplicateName: string;
  /** Numero di work order con lo stesso nome trovati */
  duplicateCount?: number;
}

/**
 * Componente per la modale di errore quando si tenta di salvare
 * un work order con un nome già esistente nel sistema
 * 
 * Questo è un dialog BLOCCANTE che impedisce il salvataggio
 */
@Component({
  selector: 'ctm-work-order-duplicate-name-dialog',
  templateUrl: './work-order-duplicate-name-dialog.component.html',
  styleUrls: ['./work-order-duplicate-name-dialog.component.scss']
})
export class WorkOrderDuplicateNameDialogComponent implements OnInit {

  /** Configurazione del pulsante di chiusura */
  closeButton!: CtButtonConfiguration;

  /** Nome duplicato da mostrare nel messaggio */
  duplicateName: string = '';

  /** Numero di duplicati trovati */
  duplicateCount: number = 1;

  constructor(
    private dialogRef: MatLegacyDialogRef<WorkOrderDuplicateNameDialogComponent>,
    private translateService: TranslateService,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: WorkOrderDuplicateNameDialogData
  ) {
    // Inizializza i dati dal dialog data
    this.duplicateName = data?.duplicateName || '';
    this.duplicateCount = data?.duplicateCount || 1;
  }

  /**
   * Inizializzazione del componente
   * Configura il pulsante con le traduzioni
   */
  ngOnInit(): void {
    this.initializeButton();
  }

  /**
   * Inizializza il pulsante di chiusura con l'etichetta tradotta
   */
  private initializeButton(): void {
    
    // Configurazione del pulsante di chiusura
    this.closeButton = CtButtonConfiguration
      .create()
      .setLabel('close')
      .setAction(() => this.onClose())
      .setMatherialOptions(MAT_RAISED_PRIMARY);
  }

  /**
   * Gestisce la chiusura del dialog
   * Questo dialog è solo informativo, non restituisce alcun valore
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
